import axios from 'axios';

const UNTAPPD_BASE_URL = 'https://api.untappd.com/v4/';
//const BEERXCHANGE_BASE_URL = "http://127.0.0.1:8000/v1/"
const BEERXCHANGE_BASE_URL = 'https://api.beerxchange.com/v1/';

class UntappdApi {
  async getUser(access_token: string) {
    const url = `${UNTAPPD_BASE_URL}user/info`;
    const params = {
      access_token,
    };
    return axios
      .get(url, {
        params,
      })
      .then((response) => response.data);
  }

  async authorizeUser(code: string) {
    const url = `${BEERXCHANGE_BASE_URL}authorize_reactweb/${code}`;
    return axios.get(url).then((response) => {
      console.log('Authorize user response: ', response.data);
      return response.data;
    });
  }

  buildQueryParams(query: string) {
    return Object.assign(
      {},
      {
        query,
      }
    );
  }
}

export default UntappdApi;
